// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"EditButton_IconButton__15scI"};